import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  MenuItem,
  Grid,
  Tooltip,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";

const MethodRangeForm = (props) => {
  const {
    investigations,
    investigationIndex,
    setInvestigations,
    isSubInvestigation,
    subInvestigationIndex,
    subInvestigationName,
    handleClose,
  } = props;

  const [methods, setMethods] = useState([]);

  useEffect(() => {
    const initialMethods = isSubInvestigation
      ? investigations[investigationIndex]?.subInvestigations[
          subInvestigationIndex
        ]?.methods || []
      : investigations[investigationIndex]?.methods || [];
    setMethods(initialMethods);
  }, []);

  const units = ["months", "years", "days"];
  const genderOptions = ["Male", "Female", "Both"];

  const handleAddMethod = () => {
    setMethods([
      ...methods,
      {
        methodName: "",
        ranges: [
          {
            fromValue: "0",
            fromUnit: "years",
            toValue: "100",
            toUnit: "years",
            gender: "Both",
            min: null,
            max: null,
            note: "",
            // results: [{ value: "" }],
          },
        ],
      },
    ]);
  };

  const handleRemoveMethod = (methodIndex) => {
    // if (methods.length === 1) return;
    const updatedMethods = methods.filter((_, index) => index !== methodIndex);
    setMethods(updatedMethods);
  };

  const handleMethodChange = (methodIndex, value) => {
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].methodName = value;
    setMethods(updatedMethods);
  };

  const handleAddRange = (methodIndex) => {
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].ranges.push({
      fromValue: "0",
      fromUnit: "years",
      toValue: "100",
      toUnit: "years",
      gender: "Both",
      min: null,
      max: null,
      unit: "",
    });
    setMethods(updatedMethods);
  };

  // const handleAddRangeResults = (methodIndex, rangeIndex) => {
  //   console.log(methodIndex, rangeIndex);
  //   const updatedMethods = [...methods];
  //   updatedMethods[methodIndex].ranges[rangeIndex].results.push({
  //     value: "",
  //   });
  //   setMethods(updatedMethods);
  // };
  // const handleRemoveRangeResults = (methodIndex, rangeIndex, resultIndex) => {
  //   // if (methods[methodIndex].ranges[rangeIndex].results.length === 1) return;
  //   const updatedMethods = [...methods];
  //   updatedMethods[methodIndex].ranges[rangeIndex].results = updatedMethods[
  //     methodIndex
  //   ].ranges[rangeIndex].results.filter((_, index) => index !== resultIndex);
  //   setMethods(updatedMethods);
  // };
  const handleRemoveRange = (methodIndex, rangeIndex) => {
    if (methods[methodIndex].ranges.length === 1) return;
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].ranges = updatedMethods[
      methodIndex
    ].ranges.filter((_, index) => index !== rangeIndex);
    setMethods(updatedMethods);
  };

  const handleRangeChange = (methodIndex, rangeIndex, field, value) => {
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].ranges[rangeIndex][field] = value;
    setMethods(updatedMethods);
  };

  const handleNoteChange = (methodIndex, rangeIndex, value) => {
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].ranges[rangeIndex].note = value;
    setMethods(updatedMethods);
  };

  const handleUnitChange = (methodIndex, rangeIndex, value) => {
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].ranges[rangeIndex].unit = value;
    setMethods(updatedMethods);
  };

  const handleRangeResultChange = (
    methodIndex,
    rangeIndex,
    resultIndex,
    value,
  ) => {
    const updatedMethods = [...methods];
    updatedMethods[methodIndex].ranges[rangeIndex].results[resultIndex].value =
      value;
    setMethods(updatedMethods);
  };

  console.log("123123", methods);

  const handleSubmit = () => {
    if (!isSubInvestigation) {
      setInvestigations((prevInvestigations) => {
        const updatedInvestigations = [...prevInvestigations];
        updatedInvestigations[investigationIndex].methods = methods;
        return updatedInvestigations;
      });
    } else {
      setInvestigations((prevInvestigations) => {
        const updatedInvestigations = [...prevInvestigations];
        updatedInvestigations[investigationIndex].subInvestigations[
          subInvestigationIndex
        ].methods = methods;
        return updatedInvestigations;
      });
    }
    handleClose();
  };

  return (
    <Box sx={{ maxWidth: "800px", margin: "auto", padding: "20px" }}>
      {methods.map((method, methodIndex) => (
        <Box
          key={methodIndex}
          sx={{
            border: "1.5px solid",
            borderColor: "rgba(42,84,166,0.25)",
            borderRadius: "16px",
            p: 2.5,
            mb: 2,
            background:
              "linear-gradient(135deg, rgba(42,84,166,0.03), rgba(185,58,207,0.02))",
            position: "relative",
            boxShadow: "0 2px 10px rgba(10,31,68,0.06)",
          }}
        >
          {/* Method index badge */}
          <Box
            sx={{
              position: "absolute",
              top: -11,
              left: -11,
              width: 26,
              height: 26,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #2a54a6, #b93acf)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 800,
              fontSize: "0.72rem",
              boxShadow: "0 3px 8px rgba(185,58,207,0.35)",
              zIndex: 1,
            }}
          >
            {methodIndex + 1}
          </Box>

          {/* Method name */}
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontSize: "0.65rem",
                fontWeight: 600,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: ".3px",
                mb: 0.6,
              }}
            >
              Method Name
            </Typography>
            <TextField
              placeholder={`Method ${methodIndex + 1} name`}
              variant="outlined"
              fullWidth
              size="small"
              value={method.methodName}
              onChange={(e) => handleMethodChange(methodIndex, e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  background: "#a3ff99",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  "& fieldset": { borderColor: "rgba(42,84,166,0.25)" },
                  "&:hover fieldset": { borderColor: "#2a54a6" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#b93acf",
                    borderWidth: "1.5px",
                  },
                },
              }}
            />
          </Box>

          {/* Ranges */}
          {method.ranges.map((range, rangeIndex) => (
            <Box
              key={rangeIndex}
              sx={{
                border: "1.5px dashed rgba(185,58,207,0.25)",
                borderRadius: "12px",
                p: 2,
                mb: 1.5,
                background: "#ffffff",
                position: "relative",
              }}
            >
              {/* Range index pill */}
              <Box
                sx={{
                  position: "absolute",
                  top: -9,
                  left: 12,
                  background: "#b93acf",
                  color: "#fff",
                  fontSize: "0.55rem",
                  fontWeight: 700,
                  px: "8px",
                  py: "1px",
                  borderRadius: "100px",
                  letterSpacing: ".4px",
                  textTransform: "uppercase",
                }}
              >
                Range {rangeIndex + 1}
              </Box>

              <Grid container spacing={1.5}>
                <Grid item xs={6} sm={3}>
                  <Typography sx={mLabelStyle}>From</Typography>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    value={range.fromValue}
                    onChange={(e) =>
                      handleRangeChange(
                        methodIndex,
                        rangeIndex,
                        "fromValue",
                        e.target.value,
                      )
                    }
                    sx={mFieldStyle}
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography sx={mLabelStyle}>From Unit</Typography>
                  <TextField
                    select
                    size="small"
                    fullWidth
                    value={range.fromUnit}
                    onChange={(e) =>
                      handleRangeChange(
                        methodIndex,
                        rangeIndex,
                        "fromUnit",
                        e.target.value,
                      )
                    }
                    sx={mFieldStyle}
                  >
                    {units.map((unit) => (
                      <MenuItem
                        key={unit}
                        value={unit}
                        sx={{ fontSize: "0.85rem" }}
                      >
                        {unit}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography sx={mLabelStyle}>To</Typography>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    value={range.toValue}
                    onChange={(e) =>
                      handleRangeChange(
                        methodIndex,
                        rangeIndex,
                        "toValue",
                        e.target.value,
                      )
                    }
                    sx={mFieldStyle}
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography sx={mLabelStyle}>To Unit</Typography>
                  <TextField
                    select
                    size="small"
                    fullWidth
                    value={range.toUnit}
                    onChange={(e) =>
                      handleRangeChange(
                        methodIndex,
                        rangeIndex,
                        "toUnit",
                        e.target.value,
                      )
                    }
                    sx={mFieldStyle}
                  >
                    {units.map((unit) => (
                      <MenuItem
                        key={unit}
                        value={unit}
                        sx={{ fontSize: "0.85rem" }}
                      >
                        {unit}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography sx={mLabelStyle}>Gender</Typography>
                  <TextField
                    select
                    size="small"
                    fullWidth
                    value={range.gender}
                    onChange={(e) =>
                      handleRangeChange(
                        methodIndex,
                        rangeIndex,
                        "gender",
                        e.target.value,
                      )
                    }
                    sx={mFieldStyle}
                  >
                    {genderOptions.map((option) => (
                      <MenuItem
                        key={option}
                        value={option}
                        sx={{ fontSize: "0.85rem" }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={mLabelStyle}>Unit</Typography>
                  <TextField
                    type="text"
                    size="small"
                    fullWidth
                    value={range.unit}
                    onChange={(e) =>
                      handleUnitChange(methodIndex, rangeIndex, e.target.value)
                    }
                    sx={mFieldStyle}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={mLabelStyle}>Min Range</Typography>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    value={range.min}
                    inputProps={{ min: 0 }}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (v >= 0 || v === "")
                        handleRangeChange(methodIndex, rangeIndex, "min", v);
                    }}
                    sx={mFieldStyle}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={mLabelStyle}>Max Range</Typography>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    value={range.max}
                    inputProps={{ min: 0 }}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (v >= 0 || v === "")
                        handleRangeChange(methodIndex, rangeIndex, "max", v);
                    }}
                    sx={mFieldStyle}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={mLabelStyle}>Note</Typography>
                  <TextField
                    multiline
                    maxRows={4}
                    size="small"
                    fullWidth
                    value={range.note}
                    onChange={(e) =>
                      handleNoteChange(methodIndex, rangeIndex, e.target.value)
                    }
                    sx={{
                      ...mFieldStyle,
                      "& .MuiOutlinedInput-root": {
                        ...mFieldStyle["& .MuiOutlinedInput-root"],
                        alignItems: "flex-start",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Remove range */}
              {method.ranges.length > 1 && (
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 1.25 }}
                >
                  <Button
                    size="small"
                    onClick={() => handleRemoveRange(methodIndex, rangeIndex)}
                    startIcon={
                      <DeleteIcon sx={{ fontSize: "0.82rem !important" }} />
                    }
                    sx={{
                      textTransform: "none",
                      fontSize: "0.72rem",
                      fontWeight: 600,
                      borderRadius: "8px",
                      px: 1.5,
                      py: 0.5,
                      color: "#dc2626",
                      border: "1.5px solid rgba(239,68,68,0.25)",
                      background: "rgba(239,68,68,0.06)",
                      "&:hover": {
                        background: "rgba(239,68,68,0.12)",
                        borderColor: "rgba(239,68,68,0.45)",
                      },
                    }}
                  >
                    Remove Range
                  </Button>
                </Box>
              )}
            </Box>
          ))}

          {/* Method actions */}
          <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>
            <Button
              size="small"
              onClick={() => handleAddRange(methodIndex)}
              startIcon={<AddIcon sx={{ fontSize: "0.85rem !important" }} />}
              sx={{
                textTransform: "none",
                fontSize: "0.75rem",
                fontWeight: 700,
                borderRadius: "9px",
                px: 1.75,
                py: 0.65,
                border: "1.5px dashed rgba(16,185,129,0.4)",
                color: "#059669",
                background: "rgba(16,185,129,0.05)",
                "&:hover": {
                  background: "rgba(16,185,129,0.1)",
                  borderColor: "rgba(16,185,129,0.6)",
                },
              }}
            >
              Add Range
            </Button>
            <Button
              size="small"
              onClick={() => handleRemoveMethod(methodIndex)}
              startIcon={<DeleteIcon sx={{ fontSize: "0.82rem !important" }} />}
              sx={{
                textTransform: "none",
                fontSize: "0.75rem",
                fontWeight: 700,
                borderRadius: "9px",
                px: 1.75,
                py: 0.65,
                border: "1.5px solid rgba(239,68,68,0.25)",
                color: "#dc2626",
                background: "rgba(239,68,68,0.05)",
                "&:hover": {
                  background: "rgba(239,68,68,0.1)",
                  borderColor: "rgba(239,68,68,0.45)",
                },
              }}
            >
              Remove Method
            </Button>
          </Box>
        </Box>
      ))}

      {/* Bottom actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
        }}
      >
        <Button
          onClick={handleAddMethod}
          startIcon={<AddIcon sx={{ fontSize: "0.9rem !important" }} />}
          sx={{
            textTransform: "none",
            fontSize: "0.82rem",
            fontWeight: 700,
            borderRadius: "10px",
            px: 2.5,
            py: 0.85,
            background: "linear-gradient(135deg, #2a54a6, #b93acf)",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(185,58,207,0.28)",
            "&:hover": {
              background: "linear-gradient(135deg,#1e3d8a,#a02db8)",
              boxShadow: "0 6px 18px rgba(185,58,207,0.4)",
            },
          }}
        >
          Add Method
        </Button>
        <Button
          onClick={handleSubmit}
          startIcon={<CheckIcon sx={{ fontSize: "0.9rem !important" }} />}
          sx={{
            textTransform: "none",
            fontSize: "0.82rem",
            fontWeight: 700,
            borderRadius: "10px",
            px: 2.5,
            py: 0.85,
            background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(16,185,129,0.28)",
            "&:hover": {
              background: "linear-gradient(135deg,#064e3b,#0f6e56)",
              boxShadow: "0 6px 18px rgba(16,185,129,0.4)",
            },
          }}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
};

export default MethodRangeForm;

const mLabelStyle = {
  fontSize: "0.62rem",
  fontWeight: 600,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.3px",
  mb: 0.5,
};

const mFieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    background: "#f8fafc",
    fontSize: "0.855rem",
    "& fieldset": { borderColor: "#e5e9ef" },
    "&:hover fieldset": { borderColor: "#2a54a6" },
    "&.Mui-focused fieldset": { borderColor: "#b93acf", borderWidth: "1.5px" },
    "&.Mui-focused": { background: "#ffffff" },
  },
};
